import { phpRequest } from "./phpRequest";

export const updateDeviceStatusAPI = (deviceIds, deviceStatus) => {
  return phpRequest.put("/devices/status/update", {
    device_ids: deviceIds,
    status: deviceStatus,
  });
};
